// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title___KA2c","text":"title_text__1gw9s","more":"title_more__3ZAze"};